import { useMemo, useState } from 'react';
import { useMediaQuery } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar } from 'swiper/modules';
import ArrowLeft from '../../../assets/icons/arrow_carrousel_left';
import ArrowRight from '../../../assets/icons/arrow_carrousel_right';
import clsx from 'clsx';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import style from './style.module.scss';

export const ProductImagesSlider = ({ images }) => {
    const isMobile = useMediaQuery(`(max-width:${style.mobileBreakpoint})`);

    const [swiper, setSwiper] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleIndexChange = (swiper) => {
        setCurrentIndex(swiper.realIndex);
    };

    const swiperProps = {
        slidesPerView: 1,
        className: style.swiper,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            disabledClass: style.disabled,
            hiddenClass: style.disabled,
        },
        pagination: {
            enabled: true,
            clickable: true,
            bulletClass: clsx('swiper-pagination-bullet', style.bullet),
            bulletActiveClass: clsx('swiper-pagination-bullet-active', style.active),
        },
        centeredSlides: true,
        onSwiper: setSwiper,
        onRealIndexChange: handleIndexChange,
        modules: [Navigation, Pagination],
        breakpoints: {
            767: {
                pagination: false,
            },
        },
    };

    const thumbnailsProps = {
        slidesPerView: 4,
        scrollbar: {
            draggable: true,
        },
        modules: [Scrollbar],
    };

    const imagesArr = useMemo(() => {
        let imagesList = [];
        images &&
            images.length > 0 &&
            images.forEach((image) => {
                image.src &&
                    imagesList.push(
                        <SwiperSlide key={image.id} className={style.slide}>
                            <img src={image.src} className={style.image} alt={image.alt} />
                        </SwiperSlide>,
                    );
            });
        return imagesList;
    }, [images]);

    return imagesArr.length > 0 ? (
        <div className={style.images}>
            <div className={style.slider}>
                <ArrowLeft className={clsx(style.prev, 'swiper-button-prev')} />
                <Swiper {...swiperProps}>{imagesArr}</Swiper>
                <ArrowRight className={clsx(style.next, 'swiper-button-next')} />
            </div>
            {!isMobile && (
                <Swiper className={style.thumbnails} {...thumbnailsProps}>
                    {images.map((image, index) => (
                        <SwiperSlide
                            key={image.id}
                            className={clsx(style.thumbnail, currentIndex === index && style.active)}
                        >
                            <Thumbnail image={image} swiper={swiper} index={index} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            )}
        </div>
    ) : null;
};

const Thumbnail = ({ index, image, swiper }) => {
    const handleClick = () => {
        swiper !== null && swiper.slideTo(index);
    };

    return (
        <img src={image.src} className={style.image} alt={image.alt} onClick={() => handleClick(index)} role="button" />
    );
};
